<template>
  <div>
    <div class="buying-select">
      <div class="buying-selectd">
        <div>已选择资源：</div>
        <div class="buying-source">
          {{ bookDetails.bookName }}
        </div>
      </div>
      <div class="special-box">
        <div class="special-box-image">
          <el-image :src="require('../../assets/image/index/book.png')" fit="fill"></el-image>
        </div>
        <div class="special-box-text">
          <div class="text-header">
            <div class="header-category">古籍</div>
            <div class="header-title">{{bookDetails.bookName}}</div>
          </div>
          <div class="text-brief">
            <span style="color: #ccc;">简介:</span>
            {{bookDetails.brief}}
          </div>
          <!-- <div class="text-button" >
              <svg  t="1644203588284" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3216" width="18" height="18" class="icon">
                  <path  d="M996.955405 145.54762c-1.815156-0.265292-18.696111-2.59707-48.78582-2.59707-56.241924 0-155.614757 8.377645-283.178365 52.30443 131.040331-74.211972 265.208316-80.983902 267.037436-80.983902a20.609007 20.609007 0 0 0-1.661566-41.190088c-8.531235 0.349069-167.134019 7.986688-313.882435 102.877481 110.975871-103.589581 273.278781-134.977824 275.415081-135.438594a20.650895 20.650895 0 0 0 16.517924-24.001954C905.862478 2.680846 881.204276 0.600398 884.443632 0c-11.826442 2.178188-272.008172 52.262542-372.567838 244.278167C411.106687 52.70935 151.399691 2.666884 139.615137 0.474733a20.609007 20.609007 0 0 0-7.442141 40.491951c2.164225 0.40492 164.760352 31.667498 275.722261 135.620111C261.035139 81.556374 102.181027 73.876867 93.649791 73.541761a20.609007 20.609007 0 1 0-1.647603 41.190088c1.843082 0.083776 136.192583 6.604377 267.442355 81.137492-127.745124-44.010562-227.243622-52.444058-283.541396-52.444058-30.089708 0-46.998589 2.359703-48.869596 2.624996A30.941436 30.941436 0 0 0 0.685857 178.960461l51.341001 684.900407a30.969361 30.969361 0 0 0 29.74064 28.609658c254.359266 9.11767 409.946097 124.142737 411.481999 125.273719a30.91351 30.91351 0 0 0 32.393561 3.029915 30.508591 30.508591 0 0 0 7.274588-5.04055c19.226695-13.683487 169.745051-115.192619 409.3457-123.75178a30.955398 30.955398 0 0 0 29.726677-28.595695l51.313076-684.91437a30.955398 30.955398 0 0 0-26.361657-32.924145zM480.920396 937.05356c-65.443371-36.680123-193.090755-93.55037-369.300556-105.027743L64.677102 205.433819c3.448797-0.083776 7.162887-0.167553 11.170194-0.167553 71.209983 0 216.939118 14.437475 405.087063 108.909386z m431.44872-105.502476c-176.209801 11.379635-303.857186 68.347621-369.314519 105.01378V313.756769c188.147945-94.56965 333.905006-108.909386 405.114988-108.909385q5.990016 0 11.170194 0.125665z m0 0" p-id="3217">

                  </path>
              </svg>
              <div>
                  在线阅读
              </div>
          </div> -->
        </div>
      </div>
    </div>
    <div class="buying-payment">
      <div class="buying-seclec">
        <div>权限级别：</div>
        <el-select @change="selectPrivilegeLevel" v-model="permLevel">
          <el-option key="READ" label="阅读" value="r"></el-option>
          <el-option key="DOWNLOAD" label="下载" value="d"></el-option>
        </el-select>
      </div>
      <!-- 暂时保留 -->
      <!-- <div class="payment-box">
          <div class="payment-item" v-for="(item, index) in oncePrice.price" :key="index" :class="permice == item.permice?'is-active':''" @click="buying(item)">
              <div class="paymen-item-box" >
                  <div class="payment-item-title">
                      {{ item.title }}
                  </div>
                  <div class="payment-item-price" >
                      <div class="price-f">￥</div>
                      <div class="price-p" style="margin: 0 0.2rem;">{{ item.price / 100 }}</div>
                      <div class="price-d" style="min-width:1.25rem;">/{{ item.day }}</div>
                  </div>
              </div>
          </div>
      </div> -->
      <div class="buying-image">
        <div class="image-box">
          <div id="qrcode2" ref="qrcode2"></div>
        </div>
        <div class="title">请使用微信/支付宝扫码支付</div>
      </div>
      <div style="display: flex;justify-content: center;align-items: center;padding-bottom: 4rem;">
        <el-button @click="paymentFinished" class="btn">支付完成</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import QRCode from 'qrcodejs2'
import {getBookById} from '../../api/resource'
import {getBookPrice,purchaseBooks,queryPayResult} from '../../api/buying'
// import {websocket} from '../../utils/plugin/websocket'
export default {
    name: 'PortalSingle',
    // mixins:[websocket],
    data() {
      return {
        datalist: [],
        bookDetails: {
          bookId: '',
          bookName: '',
          brief: '',
          pic: '',
        },

        // 权限等级存储
        lavelData: {},
        // 权限
        permLevel: 'r',
        // 单独资源下载
        oncePrice: {
          price: [],
        },
        permice: '1',
        url: '',
        tradeNo: ''
      };
    },

    mounted() {
        console.log(this.socketInit);
        this.init()
        this.initDetails()
        this.initLavel()
    },

    methods: {
      // 选择 权限等级 READ 、DOWNLOAD 、COMMERCIAL
      async selectPrivilegeLevel() {
        this.lavelChange(this.lavelData, this.permLevel)
        this.$refs.qrcode2.innerHTML = ''
        let data = await this.chaseBooks(this.permice)
        this.url = data.qrCodeUrl
        this.tradeNo = data.tradeNo
        this.$nextTick(() => {
          // 创建二维码
          this.qrcode()
        })
      },
      lavelChange(arr, m) {
        this.oncePrice.price = []
        arr[m].forEach((e, i) => {
          let obj = {
            price: e,
            title: '',
            permice: '',
            permLevel: m
          }
          if (i == 0) {
            obj.title = '一天浏览权'
            obj.day = '天',
              obj.permice = '1'
          } else if (i == 1) {
            obj.title = '包月'
            obj.day = '月'
            obj.permice = '30'
          } else if (i == 2) {
            obj.title = '包年'
            obj.day = '年'
            obj.permice = '365'
          } else if (i == 3) {
            obj.title = '终身'
            obj.day = '终身'
            obj.permice = '-1'
          }
          this.oncePrice.price = this.oncePrice.price.concat(obj)
        });
      },
      // 初始化权限等级
      async initLavel() {
        let buyData = await this.priceData()
        this.lavelData = buyData
        this.lavelChange(this.lavelData, this.permLevel)
      },

      // 初始化资源信息
      async initDetails() {
        let detailsData = await this.getDetail()
        this.datalist = JSON.parse(JSON.stringify(detailsData))
        let con = [
          {
            title: '题名',
            field: 'bookName'
          },
          {
            title: '简介',
            field: 'brief'
          },
          {
            title: 'coverPicture',
            field: 'pic'
          },
        ]
        con.forEach(e => {
          const ds = this.datalist.find(i => {
            return i.captions == e.title
          })
          if (ds) {
            this.bookDetails[e.field] = ds.attributeValue
          }
        });
      },
      // 初始化
      async init() {
        let data = await this.chaseBooks(1)
        this.url = data.qrCodeUrl
        this.tradeNo = data.tradeNo
        this.$nextTick(() => {
          // 创建二维码
          this.qrcode()
        })

      },
      getDetail() {
        return new Promise((provide, inject) => {
          getBookById({
            bookId: this.$route.query.bookId
          }).then(res => {
            if (res.data.code == 200 && res.data.data) {
              provide(res.data.data)

            }
          })
        })
      },
      // 获取 当前书籍价格
      priceData() {
        return new Promise((provide, reject) => {
          getBookPrice({
            bookId: this.$route.query.bookId,
            typeId: this.$store.state.typeId
          }).then(res => {
            if (res.data.code == 200) {
              provide(res.data.data)
            }
          })
        })
      },
      // 选择价格
      async buying(item) {
        if (item.permice === this.permice) return
        this.$refs.qrcode2.innerHTML = ''
        this.permice = item.permice
        let data = await this.chaseBooks(this.permice)
        this.url = data.qrCodeUrl
        this.tradeNo = data.tradeNo
        this.$nextTick(() => {
          // 创建二维码
          this.qrcode()
        })
      },
      // 查询价格
      chaseBooks(e) {
        return new Promise((provide, inject) => {
          purchaseBooks({
            bookIds: [this.$route.query.bookId],
            permLevel: this.permLevel == 'r' ? 'READ' : 'DOWNLOAD',
            daysFor: e
          }).then(res => {
            if (res.data.code == 200) {
              provide(res.data.data)
            } else if (res.data.code == 400) {
              this.$message({
                message: res.data.message + '正在返回请稍后',
                type: 'error'
              })
              setTimeout(() => {
                this.$router.push({
                  path: '/resource/detail',
                  query: {
                    bookId: this.$route.query.bookId
                  }
                })
              }, 500)
            } else if (res.data.code == 10006) {
              this.$message({
                message: res.data.message,
                type: 'error'
              })
            }
          })
        })
      },
      // 生成支付二维码
      qrcode() {
        const fontSize = getComputedStyle(window.document.documentElement)['font-size'].split('px')[0]
        let qrcode = new QRCode('qrcode2', {
          width: 8.333 * fontSize, // 设置宽度，单位像素
          height: 8.333 * fontSize, // 设置高度，单位像素
          text: this.url // 设置二维码内容或跳转地址
        })
      },
      // 查询支付是否成功
      paymentFinished() {
        queryPayResult({
          tradeNo: this.tradeNo
        }).then(res => {
          if (res.data.code == 200) {
            if (res.data.data.trxstatus === '0000') {
              this.$message({
                message: "支付成功，请稍后",
                type: "success",
              });
              setTimeout(() => {
                this.$router.push({
                  path: '/resource/detail',
                  query: {
                    bookId: this.$route.query.bookId
                  }
                })
              }, 1000);
            } else {
              this.$message({
                message: res.data.data.desc,
                type: "error",
              });
            }
          } else if (res.data.code == 20006) {
            this.$message({
              message: res.data.message,
              type: "error",
            });
          }
        })
      }
    },
  };
</script>

<style lang="less" scoped>
  .buying-select {
    background-color: #fff;
    padding: 0 1.563rem;
    padding-bottom: 2.083rem;

    .buying-selectd {
      display: flex;
      align-items: center;
      height: 5.729rem;

      .buying-source {
        padding: 0.677rem 1.615rem 0.573rem 1.615rem;
        background-color: #ffffff;
        border-radius: 0.313rem;
        border: solid 0.052rem #cccccc;
        font-size: 0.833rem;
        letter-spacing: 0.016rem;
        color: #333333;
      }
    }

    .special-box {
      width: 100%;
      height: 11.563rem;
      background: url('../../assets/image/buying/kuang.png') no-repeat;
      background-size: contain;
      display: flex;
      padding-left: 2.188rem;
      padding-right: 1.188rem;
      padding-top: 1.198rem;
      padding-bottom: 1.094rem;

      .special-box-image {
        margin-right: 1.042rem;

        .el-image {
          width: 6.198rem;
          height: 9.129rem;
        }
      }

      .special-box-text {
        position: relative;

        .text-header {
          display: flex;
          align-items: center;
          margin-bottom: 0.833rem;

          .header-category {
            width: auto;
            height: 1.342rem;
            line-height: 1.342rem;
            background-color: #9aca2a;
            border-radius: 7px;
            color: #fff;
            padding: 0 0.3rem;
            font-size: 0.8rem;
            margin-right: 0.26rem;
          }
        }

        .text-brief {
          font-size: 0.725rem;
          line-height: 1.3rem;
          overflow: hidden;
          text-overflow: ellipsis; //多出部分用...代替
          display: -webkit-box; //定义为盒子模型显示
          -webkit-line-clamp: 4; //用来限制在一个块元素显示的文本的行数
          -webkit-box-orient: vertical; //从上到下垂直排列子元素（设置伸缩盒子的子元素排列方式）
        }

        .text-button {
          position: absolute;
          align-items: center;
          bottom: 0rem;
          font-size: 0.625rem;
          min-width: 4.479rem;
          display: flex;
          padding: 4px 12px;
          border-radius: 5px;
          border: 1px solid #dcdfe6;
          cursor: pointer;

          svg {
            margin-right: 0.3rem;
          }
        }

        .text-button:hover {
          color: #fff;
          background-color: #b2262f;
          border-color: #b2262f;

          svg {
            path {
              fill: #fff !important;
            }

          }
        }
      }
    }
  }

  .buying-payment {
    margin-top: 1.042rem;
    width: 62.5rem;
    // min-height: 34.896rem;
    background-color: #ffffff;
    border-radius: 0.833rem;

    .buying-seclec {
      display: flex;
      align-items: center;
      padding-top: 2.083rem;
      padding-left: 1.563rem;

      div {
        font-size: 1.146rem;
        letter-spacing: 0.021rem;
        color: #333333;
      }

      /deep/ .el-select {
        width: 7.292rem;
        height: 2.083rem;

        .el-input__inner {
          text-align: center;
          height: 2.083rem;

          &:focus {
            border-color: #C0C4CC;
          }
        }
      }
    }

    .payment-box {
      display: flex;
      justify-content: space-between;
      padding: 4.167rem 4.167rem 2.064rem 4.167rem;

      .payment-item {
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        width: calc(10.938rem);
        height: calc(13.542rem);
        background: url('../../assets/image/buying/kuang2.png') no-repeat;
        background-size: cover;

        &:hover, &.is-active {
          background: url('../../assets/image/buying/kuang1.png') no-repeat;
          background-size: cover;
          box-shadow: none;
          border: unset
        }

        .paymen-item-box {
          text-align: center;

          .payment-item-title {
            font-size: 1.146rem;
            color: #333333;
          }

          .payment-item-price {
            display: flex;
            align-items: baseline;
            justify-content: center;
            text-align: center;
            margin-top: 2.188rem;

            .price-f, .price-d {
              font-size: 0.833rem;
              color: #333333;
            }

            .price-p {
              font-size: 3rem;
              color: #333333;
            }
          }
        }
      }
    }

    .buying-image {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;

      .image-box {
        width: 8.333rem;
        height: 8.333rem;
      }

      .title {
        margin: 2rem 0;
      }

    }

    .btn {
      width: 9.375rem;
      height: 2.604rem;
      background-color: #b1222b;
      border-color: #b1222b;
      border-radius: 0.313rem;
      font-size: 1.146rem;
      letter-spacing: 0.021rem;
      color: #ffffff;
    }
  }
</style>
